/**
 * Convert a hex colour to the bare HSL triplet our design tokens use ("137 78% 36%").
 *
 * The token layer stores triplets rather than full colours so alpha can compose, 
 * `hsl(var(--buy) / 0.1)` for orderbook depth bars, for example. Chart presets are authored
 * as hex because that's what Lightweight Charts consumes, so linking the two needs this.
 */
export const hexToHslTriplet = (hex: string): string | null => {
  const m = /^#?([\da-f]{3}|[\da-f]{6})$/i.exec(hex.trim());
  if (!m) return null;

  let h = m[1];
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");

  const r = parseInt(h.slice(0, 2), 16) / 255;
  const g = parseInt(h.slice(2, 4), 16) / 255;
  const b = parseInt(h.slice(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  const d = max - min;

  let hue = 0;
  let sat = 0;

  if (d !== 0) {
    sat = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    if (max === r) hue = ((g - b) / d + (g < b ? 6 : 0)) * 60;
    else if (max === g) hue = ((b - r) / d + 2) * 60;
    else hue = ((r - g) / d + 4) * 60;
  }

  return `${Math.round(hue)} ${Math.round(sat * 100)}% ${Math.round(l * 100)}%`;
};
